import { render, staticRenderFns } from "./ListAdmin.vue?vue&type=template&id=12f9ea29&scoped=true"
import script from "./ListAdmin.vue?vue&type=script&lang=js"
export * from "./ListAdmin.vue?vue&type=script&lang=js"
import style0 from "./ListAdmin.vue?vue&type=style&index=0&id=12f9ea29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9ea29",
  null
  
)

export default component.exports